import axios from 'axios';
import { IMPROVE_CONFIG } from '@/config.js';

// IMPROVE Live webinars on the website (no account). The API answers
// { data: ... }; these return that inner object. A booking's private change or
// cancel token comes back from book() and in the booking emails' link.
function data(resp) {
  return (resp && resp.data && resp.data.data) || {};
}

export default {
  sessions() {
    return axios.get(IMPROVE_CONFIG.API_URL + '/public/improve-live/sessions').then(data);
  },
  book(details) {
    return axios
      .post(IMPROVE_CONFIG.API_URL + '/public/improve-live/book', {
        session_at: details.session_at,
        first_name: details.first_name,
        last_name: details.last_name,
        email: details.email,
        company_name: details.company_name,
        phone: details.phone,
        // Honeypot: real people never fill this; the API books nothing for bots.
        company_website: details.company_website,
      })
      .then(data);
  },
  booking(token) {
    return axios.get(IMPROVE_CONFIG.API_URL + '/public/improve-live/booking/' + encodeURIComponent(token)).then(data);
  },
  move(token, sessionAt) {
    return axios
      .post(IMPROVE_CONFIG.API_URL + '/public/improve-live/booking/' + encodeURIComponent(token) + '/move', {
        session_at: sessionAt,
      })
      .then(data);
  },
  cancel(token) {
    return axios
      .post(IMPROVE_CONFIG.API_URL + '/public/improve-live/booking/' + encodeURIComponent(token) + '/cancel', {})
      .then(data);
  },
};
